import { Sheets } from "common/sheets";
import * as PIXI from "pixi.js";
import { spritesDurations } from "./sound";
const angle = 82;
const initialPointX = 60;
const spriteAngle = -6;
const mask = {
    x: 50,
    y: 330,
    w: 700,
    h: 350,
    angle: spriteAngle,
};
// angle
class Controller {
    constructor(pixiContext, message) {
        this.pixiContext = pixiContext;
        this.message = message;
    }
    setSpritePosition({ x, y, angle, deltaX, spriteAngle, }) {
        this.message.sprite.angle = spriteAngle;
        const newY = y + deltaX * getTanDeg(angle);
        const newX = x + deltaX;
        this.message.sprite.position.set(newX, newY);
    }
    setScrollZero() {
        const newY = 0 + 100 * getTanDeg(angle);
        const newX = 50 + 100;
        this.message.sprite.position.set(newX, newY);
    }
    scroll({ deltaX }) {
        const x = this.message.sprite.position.x;
        const y = this.message.sprite.position.y;
        const newY = y + deltaX * getTanDeg(angle);
        const newX = x + deltaX;
        this.message.sprite.position.set(newX, newY);
    }
    // x y w h
    setMaskPosition({ x, y, w, h, angle, }) {
        const graphics = new PIXI.Graphics();
        graphics.beginFill(0xff3300);
        graphics.drawPolygon(createMaskRect({
            x,
            y,
            w,
            h,
            angle,
        }));
        graphics.endFill();
        this.message.sprite.mask = graphics;
    }
}
const deltaXForTabNum = [initialPointX, 0, -20, -40, -65, -85];
export class Message {
    constructor(pixiContext, sheets) {
        this.state = {
            type: "idle",
        };
        this.tabNum = 0;
        this.pixiContext = pixiContext;
        this.sprite = Sheets.sprite(sheets, "text message.png");
        this.sprite.mask = createMask();
        this.sprite.angle = spriteAngle;
        this.sprite.x = 50;
        const { x: newX, y: newY } = translate({ x: this.sprite.x, y: this.sprite.y }, initialPointX);
        this.sprite.position.set(newX, newY);
        console.log("controller", new Controller(this.pixiContext, this));
    }
    isScrolling() {
        return this.state.type === "scrolling";
    }
    async scroll() {
        if (this.state.type === "scrolling") {
            return;
        }
        this.tabNum += 1;
        const deltaX = deltaXForTabNum[this.tabNum] - deltaXForTabNum[this.tabNum - 1];
        let durationMS = spritesDurations[`speaking${this.tabNum - 1}`];
        if (this.tabNum === 6) {
            durationMS -= 2500;
        }
        else {
            durationMS -= 1000;
        }
        const startPoint = {
            x: this.sprite.x,
            y: this.sprite.y,
        };
        this.state.type = "scrolling";
        await this.pixiContext.animate({
            start: 0,
            destination: 1,
            durationMS: durationMS,
            setter: (value) => {
                const { x: newX, y: newY } = translate({ x: startPoint.x, y: startPoint.y }, value * deltaX);
                this.sprite.position.set(newX, newY);
            },
        });
        this.state.type = "idle";
    }
}
function createMask() {
    const graphics = new PIXI.Graphics();
    graphics.beginFill(0xff3300);
    graphics.drawPolygon(createMaskRect(mask));
    graphics.endFill();
    return graphics;
}
function createMaskRect({ x, y, w, h, angle, }) {
    const pointLT = new PIXI.Point(x, y);
    const pointRTRot = rotate({ x: w, y: 0 }, angle);
    const pointRT = new PIXI.Point(x + pointRTRot.x, y + pointRTRot.y);
    const pointLBRot = rotate({ x: 0, y: h }, angle);
    const pointLB = new PIXI.Point(x + pointLBRot.x, y + pointLBRot.y);
    const pointRBRot = rotate({ x: w, y: h }, angle);
    const pointRB = new PIXI.Point(x + pointRBRot.x, y + pointRBRot.y);
    return [pointLT, pointRT, pointRB, pointLB];
}
function translate(pos, x) {
    const y = x * getTanDeg(angle);
    return {
        x: pos.x + x,
        y: pos.y + y,
    };
}
function getTanDeg(deg) {
    const rad = (deg * Math.PI) / 180;
    return Math.tan(rad);
}
export const fileName = "text message.png";
function rotate(point, deg) {
    const radian = (deg * Math.PI) / 180;
    return {
        x: point.x * Math.cos(radian) - point.y * Math.sin(radian),
        y: point.x * Math.sin(radian) + point.y * Math.cos(radian),
    };
}
//# sourceMappingURL=message.js.map